(function(){
    'use strict';
    angular
        .module('MW.CoreStream.SourceCard', [
            'MW.Framework.TranslationService',
            'MW.Framework.TextFilters'
        ])
        .directive('sourceCard', function () {
            return {
                restrict: 'E',
                templateUrl: 'icm-web/views/partials/source_card',
                scope: {
                    source: '=',
                    showRelevantArticles: '&?',
                    relevantArticleCount: '@?'
                },
                controller: SourceCardController,
                controllerAs: 'sourceCardController'
            };
        })
        .controller('sourceCardController', [
            '$scope',
            'translationService',
            SourceCardController
        ]);
    function SourceCardController($scope, translationService) {
        this.translationService = translationService;
        this.relevantArticle = this.translationService.getLocalizedString('[[ArticleCount]] Relevant Article', {ArticleCount: $scope.relevantArticleCount});
        this.relevantArticles = this.translationService.getLocalizedString('[[ArticleCount]] Relevant Articles', {ArticleCount: $scope.relevantArticleCount});

        // Can be removed after old search pages is removed
        this.getBeatName = function getBeatName(beat) {
            if (typeof beat === 'string') {
                // New CSS
                return beat;
            }
            else {
                // Old CSS
                return beat.name;
            }
        };

        this.getCity = function getCity(contactInfo) {
            var address;
            if (contactInfo && contactInfo.addresses) {
                address = contactInfo.addresses[0];
                if (address && address.city) {
                    return address.city;
                }
            }
            return null;
        };
        this.getStateOrProvince = function getStateOrProvince(contactInfo) {
            var address;
            if (contactInfo && contactInfo.addresses) {
                address = contactInfo.addresses[0];
                if (address && address.stateOrProvince) {
                    return address.stateOrProvince;
                }
            }
            return null;
        };
        this.getCountry = function getCountry(contactInfo) {
            var address;
            if (contactInfo && contactInfo.addresses) {
                address = contactInfo.addresses[0];
                if (address && address.countryName) {
                    return address.countryName;
                }
            }
            return null;
        };
        this.city = $scope.source.city ? $scope.source.city : this.getCity($scope.source.contactInfo);
        this.stateOrProvince = $scope.source.stateOrProvince ? $scope.source.stateOrProvince : this.getStateOrProvince($scope.source.contactInfo);
        this.country = $scope.source.country ? $scope.source.country : this.getCountry($scope.source.contactInfo);

    }
})();
